import styled from '@emotion/styled'
import { ICellRendererParams } from 'ag-grid-community'
import React from 'react'
import * as gridIcons from '../styles/gridIconSet'
import * as constants from 'view/styles/constants'

interface MasterDetailCellRendererProps extends ICellRendererParams {
  isRowMaster: (rowData: any) => boolean
}

export const MasterIcon = styled.button<{ isExpanded: boolean }>`
  background-color: transparent;
  border-color: transparent;
  margin: 0;
  color: ${constants.CORE_PRIMARY_5};
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border-width: 2px;
  border-style: solid;
  border-radius: 6px;
  cursor: pointer;

  svg {
    transform: rotate(${props => (props.isExpanded ? 0 : 270)}deg);
    color: ${constants.CORE_PRIMARY_5};
    width: 12px;
    height: 12px;
  }

  &:hover {
    background-color: ${constants.CORE_PRIMARY};
    border-color: ${constants.CORE_PRIMARY_3};

    svg {
      color: ${constants.CORE_PRIMARY_6};
    }
  }
`

export const MasterDetailCellRenderer = ({ node, isRowMaster }: MasterDetailCellRendererProps) => {
  if (node.group || !isRowMaster(node.data)) return null

  return (
    <MasterIcon
      aria-label={!node.expanded ? 'Expand Detail' : 'Collapse Detail'}
      onClick={() => node.setExpanded(!node.expanded)}
      isExpanded={node.expanded}>
      {gridIcons.downArrowIcon}
    </MasterIcon>
  )
}
